import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { PatternFormat } from 'react-number-format'

const FormInputPhone = forwardRef(({ name, label, control, errors, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <PatternFormat
                    {...field}
                    ref={ref}
                    format='(##) # ####-####'
                    
                    mask='_'
                    customInput={TextField}
                    label={label}
                    placeholder={label}
                    error={!!errors}
                    helperText={errors?.message}
                    InputLabelProps={{ shrink: true }}
                    {...props}
                />
            )}
        />
    )
})

FormInputPhone.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

FormInputPhone.displayName = 'FormInputPhone'

export default FormInputPhone